import { jsx as _jsx } from "react/jsx-runtime";
import { withStyle } from 'styletron-react';
import { StyledLayoutBase, layoutBasePropsToStyledProps } from './LayoutBase';
const StyledHiddenContainer = withStyle(StyledLayoutBase, {
    visibility: 'hidden',
});
export const HiddenContainer = ({ children, ...layoutBaseProps }) => (_jsx(StyledHiddenContainer, { ...layoutBasePropsToStyledProps(layoutBaseProps), children: children }));
